module.exports = __webpack_public_path__ + "img/gold-tier-badge-icon.f3a2cfaf.svg";